import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d86ce69"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d86ce69')) {
      api.createRecord('5d86ce69', component.options)
    } else {
      api.reload('5d86ce69', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5d86ce69", function () {
      api.rerender('5d86ce69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/reminderManage/index.vue"
export default component.exports